import script from "./AuthLandingLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLandingLogo.vue?vue&type=script&setup=true&lang=js"

import "./AuthLandingLogo.vue?vue&type=style&index=0&id=ed8ec9ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed8ec9ac"]])

export default __exports__